import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Switch } from '@/components/ui/switch';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { ICreateVoiceAgentFormData } from '@/@types/voiceAgents';

interface IAgentFormSecurityTabProps {
  // LOCAL_TYPE_JUSTIFIED: single-use props interface for this tab sub-component
  form: ICreateVoiceAgentFormData;
  setField: (field: string, value: string | number | boolean | string[] | undefined) => void;
}

export function AgentFormSecurityTab({ form, setField }: IAgentFormSecurityTabProps) {
  return (
    <div className="space-y-4 mt-4">
      <div className="flex items-center justify-between">
        <div>
          <Label>Require Recording Consent</Label>
          <p className="text-xs text-muted-foreground">Ask caller for consent before recording</p>
        </div>
        <Switch
          checked={form.requireConsent}
          onCheckedChange={v => setField('requireConsent', v)}
        />
      </div>
      {form.requireConsent && (
        <div className="space-y-2">
          <Label htmlFor="consent-message">Consent Message</Label>
          <Textarea
            id="consent-message"
            value={form.consentMessage ?? ''}
            onChange={e => setField('consentMessage', e.target.value || undefined)}
            placeholder="This call may be recorded for quality assurance..."
            rows={2}
          />
        </div>
      )}
      <div className="flex items-center justify-between">
        <div>
          <Label>Require Verification</Label>
          <p className="text-xs text-muted-foreground">Verify caller identity before proceeding</p>
        </div>
        <Switch
          checked={form.verificationRequired}
          onCheckedChange={v => setField('verificationRequired', v)}
        />
      </div>
      {form.verificationRequired && (
        <div className="space-y-2">
          <Label htmlFor="verification-method">Verification Method</Label>
          <Select
            value={form.verificationMethod}
            onValueChange={v => setField('verificationMethod', v)}
          >
            <SelectTrigger id="verification-method">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="policy_number">Policy Number</SelectItem>
              <SelectItem value="dob">Date of Birth</SelectItem>
              <SelectItem value="pin">PIN</SelectItem>
              <SelectItem value="none">None</SelectItem>
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
}
